<template>
  <HeaderPopup v-bind:onCloseClick="onCloseClick">
    <div class="themes-block">
      <div class="block block-layouts" v-if="isPresentation">
        <div class="title">Select a Layout & Colors</div>
        <LayoutSelect />
      </div>
      <div class="block">
        <div class="title" v-if="!isPresentation">
          Select a Layout and Colors
        </div>
        <ThemeSelect />
      </div>
      <button
        v-if="isPresentation"
        @click="setRandomTheme"
        v-bind:class="{
          'random-button': true,
          'random-button-loading': fakeLoading,
        }"
      >
        <RefreshIcon />
        <span class="random-button-text">RANDOMIZE</span>
      </button>
    </div>
  </HeaderPopup>
</template>

<script>
import { mapState } from "vuex";
import HeaderPopup from "./HeaderPopup";
import ThemeSelect from "../ThemeSelect";
import LayoutSelect from "../LayoutSelect";
import RefreshIcon from "../icons/RefreshIcon";
import getRandomLayout from "../../getRandomLayout";
import uniq from "../../helpers/uniq";

export default {
  name: "ThemesBlock",
  components: {
    LayoutSelect,
    HeaderPopup,
    ThemeSelect,
    RefreshIcon,
  },
  props: {
    onCloseClick: Function,
  },
  computed: {
    ...mapState("app", ["isPresentation", "themes"]),
    ...mapState("auth", ["theme"]),
  },
  data() {
    return {
      fakeLoading: false,
    };
  },
  methods: {
    setRandomTheme() {
      if (this.fakeLoading) return false;

      this.fakeLoading = true;
      setTimeout(() => {
        this.fakeLoading = false;
      }, 2000);

      const themesArr = uniq(
        this.themes.map((theme) =>
          theme.title.split("-").slice(0, -1).join("-")
        )
      ).filter((themeName) => this.theme !== themeName);
      const themeIdx = Math.floor(Math.random() * themesArr.length);
      const layout = getRandomLayout();
      const themeName = `${themesArr[themeIdx]}`;
      if (layout !== this.$route.params.layout) {
        this.$router.push(`/sportsbook/${layout}${window.location.search}`);
      }
      this.$store.dispatch("auth/selectTheme", { theme: themeName });
    },
  },
};
</script>

<style scoped>
.themes-block {
  padding: 0 16px 24px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.block {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.block:last-of-type {
  padding-bottom: 0;
}
.title {
  color: #1e313a;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  margin-bottom: 4px;
}
.block-layouts {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
}
.block-layouts .title {
  margin-bottom: 8px;
}
.random-button {
  display: flex;
  align-items: center;
  margin-top: 24px;
  color: #929ca2;
  font-size: 11px;
  font-weight: bold;
  border: none;
  background: transparent;
  cursor: pointer;
}

.random-button-loading {
  color: #d2d6d8;
  cursor: default;
}

.random-button-text {
  margin-left: 4px;
}

@media (max-width: 370px) {
  .themes-block {
    padding: 12px;
  }
}
</style>
